<script>


export default {
	name: 'IconSvgAvi',

	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.4029 4.10333C12.9381 4.10289 12.4925 3.92174 12.1638 3.59961C11.8351 3.27748 11.6501 2.84067 11.6494 2.385V0H3.81493C3.20829 0 2.62649 0.236264 2.19753 0.656815C1.76857 1.07736 1.52759 1.64775 1.52759 2.2425V15.7608C1.52826 16.3551 1.76958 16.9247 2.19849 17.3446C2.6274 17.7645 3.20881 18.0002 3.81493 18H13.2159C13.8226 18 14.4044 17.7637 14.8333 17.3432C15.2623 16.9226 15.5033 16.3523 15.5033 15.7575V4.10333H13.4029Z"
				:fill="color" />
			<path
				d="M15.5033 4.10333H13.403C12.9382 4.10289 12.4925 3.92174 12.1638 3.59961C11.8351 3.27748 11.6501 2.84067 11.6494 2.385V0L15.5033 4.10333Z"
				fill="#0055A3" />
			<path
				d="M17.1624 14.2166H6.53404C5.78012 14.2166 5.16895 14.8157 5.16895 15.5549V18.6615C5.16895 19.4007 5.78012 19.9999 6.53404 19.9999H17.1624C17.9164 19.9999 18.5275 19.4007 18.5275 18.6615V15.5549C18.5275 14.8157 17.9164 14.2166 17.1624 14.2166Z"
				fill="#0055A3" />
			<path d="M15.335 15.8555V18.3612H14.7196V15.8555H15.335Z" fill="#F3F3F6" />
			<path d="M9.00162 17.7552V18.3611H8.36157V17.7552H9.00162Z" fill="#F3F3F6" />
			<path
				d="M10.91 17.9044H9.95117L9.79222 18.361H9.14197L10.077 15.8735H10.7867L11.7217 18.361H11.0638L10.91 17.9044ZM10.7502 17.4435L10.4323 16.5219L10.111 17.4435H10.7502Z"
				fill="#F3F3F6" />
			<path
				d="M12.4427 15.8552L13.0683 17.7411L13.6939 15.8552H14.3569L13.4678 18.3611H12.6688L11.7831 15.8552H12.4427Z"
				fill="#F3F3F6" />
			<path
				d="M8.50178 12.4858C7.57446 12.4847 6.68546 12.123 6.02975 11.4802C5.37403 10.8373 5.00515 9.96574 5.00403 9.0566C5.00515 8.14747 5.37403 7.27589 6.02975 6.63304C6.68546 5.99018 7.57446 5.62854 8.50178 5.62744C9.4291 5.62854 10.3181 5.99018 10.9738 6.63304C11.6295 7.27589 11.9984 8.14747 11.9995 9.0566C11.9984 9.96574 11.6295 10.8373 10.9738 11.4802C10.3181 12.123 9.4291 12.4847 8.50178 12.4858ZM8.50178 6.22827C7.73707 6.22959 7.00407 6.528 6.46334 7.05813C5.92261 7.58826 5.61823 8.30689 5.61689 9.0566C5.61688 9.80719 5.92066 10.5271 6.46154 11.0583C7.00242 11.5895 7.73619 11.8886 8.50178 11.8899C9.26737 11.8886 10.0012 11.5895 10.542 11.0583C11.0829 10.5271 11.3867 9.80719 11.3867 9.0566C11.3853 8.30689 11.081 7.58826 10.5402 7.05813C9.99949 6.528 9.26649 6.22959 8.50178 6.22827Z"
				fill="#0055A3" />
			<path
				d="M9.50498 8.82171L8.69152 8.36171C8.64942 8.33788 8.60166 8.32533 8.55304 8.32532C8.50442 8.32531 8.45666 8.33783 8.41454 8.36164C8.37243 8.38546 8.33744 8.41971 8.3131 8.46097C8.28876 8.50223 8.27593 8.54905 8.27588 8.59671V9.51755C8.27593 9.56521 8.28876 9.61202 8.3131 9.65328C8.33744 9.69455 8.37243 9.7288 8.41454 9.75261C8.45666 9.77643 8.50442 9.78895 8.55304 9.78894C8.60166 9.78893 8.64942 9.77638 8.69152 9.75255L9.50498 9.29171C9.54697 9.26783 9.58183 9.23355 9.60606 9.19231C9.63029 9.15107 9.64305 9.10431 9.64305 9.05671C9.64305 9.00912 9.63029 8.96236 9.60606 8.92111C9.58183 8.87987 9.54697 8.84559 9.50498 8.82171Z"
				fill="#0055A3" />
			<path
				d="M7.85845 8.29004H7.56095C7.45016 8.29004 7.36035 8.37809 7.36035 8.4867V9.62754C7.36035 9.73616 7.45016 9.82421 7.56095 9.82421H7.85845C7.96924 9.82421 8.05905 9.73616 8.05905 9.62754V8.4867C8.05905 8.37809 7.96924 8.29004 7.85845 8.29004Z"
				fill="#0055A3" />
		</svg>
	</div>

</template>

<style scoped>

</style>